import { render, staticRenderFns } from "./assistInfo.vue?vue&type=template&id=22e467d0&scoped=true&"
import script from "./assistInfo.vue?vue&type=script&lang=js&"
export * from "./assistInfo.vue?vue&type=script&lang=js&"
import style0 from "./assistInfo.vue?vue&type=style&index=0&id=22e467d0&scoped=true&rel=stylesheet%2Fscss&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e467d0",
  null
  
)

export default component.exports